// One push per chunk keeps the id list in the mutation, and the `IN` list on the
// server, bounded however many rows the filter matched.
export const CONTACT_DELETE_CHUNK_SIZE = 200
// A subscription push is a few statements on the server, and 1,000 ids keep
// each one far under Postgres's bind limit.
export const SUBSCRIPTION_CHUNK_SIZE = 1000

export function chunkContactIds(
	ids: readonly string[],
	size = CONTACT_DELETE_CHUNK_SIZE,
): string[][] {
	const chunks: string[][] = []
	for (let i = 0; i < ids.length; i += size) {
		chunks.push(ids.slice(i, i + size))
	}
	return chunks
}
